import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_unpick_inventory_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { licenseplateId: number, lotId: number, packagingId: number, unpickPackagedAmount: number, targetLicensePlate: { id?: number, lookupcode?: string, locationId?: number }, serialNumberIds?: number[], shipmentLineId: number, notes?: string }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplateId)) {
      missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (isNil(inParams.lotId)) {
      missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil(inParams.packagingId)) {
      missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil(inParams.unpickPackagedAmount)) {
      missingRequiredInParams.push('\'unpickPackagedAmount\'');
    }
    if (isNil(inParams.targetLicensePlate)) {
      missingRequiredInParams.push('\'targetLicensePlate\'');
    }
    if (isNil(inParams.shipmentLineId)) {
      missingRequiredInParams.push('\'shipmentLineId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/functions/unpick_inventory_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

